export default __webpack_public_path__ + "static/media/aiCompanion.2528805d.svg";